import React from 'react'

const Colors = () => {
  return (
    <div className='colors'>
      <iframe title="marterial-io for development" src='https://material.io/develop/' />
    </div>
  )
}

export default Colors